import { Container } from 'inversify';
import GAME_PARTS from './identifiers';
import TouchZone from './TouchZone';
// import InfoPages from './InfoPages';
import IdleAnimation from './Animations/IdleAnimation';
import WinController from './WinController';
import FreeSpins from './Animations/FreeSpins';
import ReSpin from './Animations/ReSpin';
import Board from './Animations/Board';
import Win from "./Animations/Win";
import BigWin from './Animations/BigWin';


export function defineGameParts(container: Container) {
    container.bind<TouchZone>(GAME_PARTS.TouchZone).to(TouchZone).inSingletonScope();
    // container.bind<InfoPages>(GAME_PARTS.InfoPages).to(InfoPages).inRequestScope();
    container.bind<IdleAnimation>(GAME_PARTS.IdleAnimation).to(IdleAnimation).inSingletonScope();
    container.bind<WinController>(GAME_PARTS.WinController).to(WinController).inSingletonScope();
    container.bind<FreeSpins>(GAME_PARTS.FreeSpins).to(FreeSpins).inSingletonScope();
    container.bind<ReSpin>(GAME_PARTS.ReSpin).to(ReSpin).inSingletonScope();   
    container.bind<Board>(GAME_PARTS.Board).to(Board).inSingletonScope();
    container.bind<Win>(GAME_PARTS.IdleWin).to(Win).inSingletonScope();    
    container.bind<BigWin>(GAME_PARTS.BigWin).to(BigWin).inSingletonScope();
}
